export default __webpack_public_path__ + "static/media/pic1.592b5efb.jpg";